export const COOKIE_KEYS = {
  FIRST_TOUCH: {
    SOURCE: 'first_touch_attr_source',
    MEDIUM: 'first_touch_attr_medium',
    CAMPAIGN: 'first_touch_attr_campaign',
    CONTENT: 'first_touch_attr_content',
  },
  LAST_TOUCH: {
    SOURCE: 'last_touch_attr_source',
    MEDIUM: 'last_touch_attr_medium',
    CAMPAIGN: 'last_touch_attr_campaign',
    CONTENT: 'last_touch_attr_content',
  },
};

export const CLICK_ID_COOKIE_KEYS = {
  GCLID: 'alitu_gclid',
  GBRAID: 'alitu_gbraid',
  WBRAID: 'alitu_wbraid',
} as const;

export const CELLO_COOKIE_KEYS = {
  REFERRAL: 'cello-referral',
} as const;

type UtmCookies = {
  source: string | undefined;
  medium: string | undefined;
  campaign: string | undefined;
  content: string | undefined;
};

function getCookies() {
  return document.cookie.split(';').reduce<Record<string, string>>((previous, current) => {
    const trimmedCookie = current.trim();
    const separatorIndex = trimmedCookie.indexOf('=');
    const key = separatorIndex === -1 ? trimmedCookie : trimmedCookie.slice(0, separatorIndex);
    const value = separatorIndex === -1 ? '' : trimmedCookie.slice(separatorIndex + 1);

    previous[key] = value;
    return previous;
  }, {});
}

/**
 * @description
 * Cookies are set in the alitu.com marketing site. We can access them here.
 */
export function getUtmCookies(): {
  firstTouch: UtmCookies;
  lastTouch: UtmCookies;
} | null {
  const cookies = getCookies();

  return {
    firstTouch: {
      source: cookies[COOKIE_KEYS.FIRST_TOUCH.SOURCE],
      medium: cookies[COOKIE_KEYS.FIRST_TOUCH.MEDIUM],
      campaign: cookies[COOKIE_KEYS.FIRST_TOUCH.CAMPAIGN],
      content: cookies[COOKIE_KEYS.FIRST_TOUCH.CONTENT],
    },
    lastTouch: {
      source: cookies[COOKIE_KEYS.LAST_TOUCH.SOURCE],
      medium: cookies[COOKIE_KEYS.LAST_TOUCH.MEDIUM],
      campaign: cookies[COOKIE_KEYS.LAST_TOUCH.CAMPAIGN],
      content: cookies[COOKIE_KEYS.LAST_TOUCH.CONTENT],
    },
  };
}

export function getClickIdCookies(): {
  gclid: string | null;
  gbraid: string | null;
  wbraid: string | null;
} {
  const cookies = getCookies();

  return {
    gclid: cookies[CLICK_ID_COOKIE_KEYS.GCLID]
      ? decodeURIComponent(cookies[CLICK_ID_COOKIE_KEYS.GCLID])
      : null,
    gbraid: cookies[CLICK_ID_COOKIE_KEYS.GBRAID]
      ? decodeURIComponent(cookies[CLICK_ID_COOKIE_KEYS.GBRAID])
      : null,
    wbraid: cookies[CLICK_ID_COOKIE_KEYS.WBRAID]
      ? decodeURIComponent(cookies[CLICK_ID_COOKIE_KEYS.WBRAID])
      : null,
  };
}

/**
 * @description
 * Cello's attribution script captures the `ucc` referral code from the landing-page URL and stores
 * it in the first-party `cello-referral` cookie (shared across `.alitu.com`). Read it here at signup
 * — the `ucc` is usually NOT present in the app signup URL, only in this cookie.
 */
export function getCelloReferralUcc(): string | null {
  const cookies = getCookies();

  return cookies[CELLO_COOKIE_KEYS.REFERRAL] || null;
}
